export default __webpack_public_path__ + "13f474833f8b78faa91d8da0701c24f8.png";